module.exports = __webpack_public_path__ + "img/property_2_flex.b72f9c5f.jpg";